export const listingListData = [

    {
          "id": 1,
          "category": "Ferrari",
          "title": "Ferrari 458 MM Speciale",
          "rating": 5.0,
          "price": 400,
          "currency": "USD",
          "details": {
            "auto": "Auto",
            "distance": "10 KM",
            "fuel": "Petrol",
            "power": "Power",
            "year": 2018,
            "persons": "5 Persons"
          },
          "location": {
            "icon": "car-list-icon-01.png",
            "name": "Toyota Of Lincoln Park",
            "address": "Newyork, USA"
          },
          "button": "Rent Now",
          "image": "car-list-1.jpg"
        },
        {
          "id": 2,
          "category": "BMW",
          "title": "Ferrari 458 MM Speciale",
          "rating": 5.0,
          "price": 400,
          "currency": "USD",
          "details": {
            "auto": "Auto",
            "distance": "10 KM",
            "fuel": "Petrol",
            "power": "Power",
            "year": 2018,
            "persons": "5 Persons"
          },
          "location": {
            "icon": "car-list-icon-02.png",
            "name": "Toyota Of Lincoln Park",
            "address": "Newyork, USA"
          },
          "button": "Rent Now",
          "image": "car-list-2.jpg"
        },
        {
          "id": 3,
          "category": "Ford",
          "title": "Ferrari 458 MM Speciale",
          "rating": 5.0,
          "price": 400,
          "currency": "USD",
          "details": {
            "auto": "Auto",
            "distance": "10 KM",
            "fuel": "Petrol",
            "power": "Power",
            "year": 2018,
            "persons": "5 Persons"
          },
          "location": {
            "icon": "car-list-icon-03.png",
            "name": "Toyota Of Lincoln Park",
            "address": "Newyork, USA"
          },
          "button": "Rent Now",
          "image": "car-list-3.jpg"
        }
    
]